// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"365":"cb355538","630":"bee240a3"}[chunkId] || chunkId) + "." + {"206":"bbac07ec491f1b0c","365":"2d982a084e92b7c5","630":"57987ac4368611d5","733":"541d4cc012049312"}[chunkId] + ".js";
};